import React, { useState, useEffect } from 'react';
import styles from './styles.scss';

const FetchingData = ({ name }) => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prevDots => (prevDots.length < 4 ? `${prevDots}.` : ''));
    }, 500);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return (
    <div className={styles.fetchingData}>
      Fetching {name || 'data'} {dots}
    </div>
  );
};

export default FetchingData;
